<template>
  
  <v-container class="py-3">
    <v-app-bar
    app
    flat
    height="60"
    class="card-background"
  >
    <!-- Chap taraf - Avatar va App nomi -->
    <!-- <v-avatar size="48" color="#f7d9b9" class="mr-3">
      <span class="avatar-text">Sovchilar</span>
    </v-avatar> -->
    <v-spacer></v-spacer>
    <v-btn color="#f7d9b9" @click="showAll" rounded>Sovchilar</v-btn>


    <v-spacer></v-spacer>

    <!-- O'ng taraf - Qidiruv va Chat tugmalari -->
    <v-btn icon class="action-btn" color="white" @click="searchDialog = true">
      <v-icon>mdi-magnify</v-icon>
    </v-btn>

  </v-app-bar>
    <v-row dense>
      <v-col
      v-for="candidate in candidates"
      :key="candidate.id"
      cols="6"
      class="pa-1"
    >
      <v-card
        class="pa-3 d-flex flex-column justify-space-between"
        elevation="3"
        rounded="xl"
        style="min-height: 140px;"
        @click="openCandidate(candidate)"
      >
        <!-- Sarlavha -->
        <!-- <div class="d-flex align-center justify-space-between mb-2">
          <span
            :style="{ color: candidate.gender == 'A' ? '#FF9800' : '#673AB7' }"
            class="font-weight-bold text-subtitle-1"
          >
            {{ candidate.gender == 'A' ? 'Kelin' : 'Kuyov' }}
          </span>
          <v-chip x-small class="ml-1" color="success" variant="flat">
            {{ candidate.region.name }}
          </v-chip>
        </div> -->

        <v-row no-gutters>
            <!-- Avatar -->
            <v-col cols="3" class="d-flex justify-center">
              <v-avatar size="50" tile>
                <v-img
                  :src="candidate.gender=='A' ? require('@/assets/girl.jpg') : require('@/assets/boy2.jpeg')"
                  class="elevation-2"
                  style="background-color: #A259FF; border-radius: 20px;"
                ></v-img>
              </v-avatar>
            </v-col>

            <!-- Info -->
            <v-col cols="9" class="pl-4">
              <h5 :style="{ color: candidate.gender == 'A' ? 'orange' : 'purple' }" class="font-weight-bold mb-1">{{ candidate.gender == 'A' ? 'Kelin' : 'Kuyov' }}</h5>
              <v-chip x-small class="" color="success" variant="flat">
                {{ candidate.region?.name }}
              </v-chip>
            </v-col>
          </v-row>

        <!-- Chiplar (balandlik bir xil bo‘lishi uchun min-height berilgan) -->
        <div class="d-flex flex-wrap mt-2" style="min-height: 40px;">
          <v-chip
            v-for="(item, index) in [
              candidate.nationality,
              candidate.education?.name,
              candidate.profession,
              candidate.marital_status?.name
            ].filter(Boolean)"
            :key="index"
            x-small
            color="secondary"
            variant="flat"
            class="mx-1"
          >
            {{ item }}
          </v-chip>
        </div>

        <!-- Statistikalar (doim bir joyda turadi) -->
        <v-row>
          <v-col cols="4" class="text-center">
            <v-icon size="18" color="deep-purple">mdi-cake-variant-outline</v-icon>
            <div class="text-caption font-weight-bold">{{ candidate.age }}</div>
          </v-col>
          <v-col cols="4" class="text-center">
            <v-icon size="18" color="deep-purple">mdi-human-male-height</v-icon>
            <div class="text-caption font-weight-bold">{{ candidate.height }}</div>
          </v-col>
          <v-col cols="4" class="text-center">
            <v-icon size="18" color="deep-purple">mdi-weight-kilogram</v-icon>
            <div class="text-caption font-weight-bold">{{ candidate.weight }}</div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>


    </v-row>

    <div
      v-if="hasMore"
      v-intersect="handleIntersect"
      style="height: 1px;"
    ></div>

    <!-- Yuklanmoqda indikatori -->
    <div class="text-center my-3" v-if="fetchingMore">
      <v-progress-circular indeterminate size="24"></v-progress-circular>
    </div>

    <!-- End-of-list xabari -->
    <div class="text-center my-3" v-if="!hasMore && candidates.length" style="color:white">
      <small>Boshqa nomzodlar topilmadi</small>
    </div>
    <v-bottom-sheet v-model="searchDialog" inset>
  <v-card class="pa-4 rounded-t-xl" style="font-family: 'Roboto', sans-serif; font-size:14px;">

    <v-form ref="form" lazy-validation>
      <!-- Gender Toggle -->
      <v-row justify="center" class="mb-2">
        <v-col cols="12" class="d-flex justify-center">
        <v-btn-toggle
          v-model="form.gender"
          mandatory
          class="rounded-pill"
        >
          <v-btn
            value="E"
            class="px-5 py-2 mx-2 rounded-pill text-capitalize"
            :class="form.gender === 'E' ? 'blue dark white--text' : 'grey lighten-3'"
          >
            Kuyov
          </v-btn>
          <v-btn
            value="A"
            class="px-5 py-2 rounded-pill text-capitalize"
            :class="form.gender === 'A' ? 'pink white--text' : 'grey lighten-3'"
          >
            Kelin
          </v-btn>
        </v-btn-toggle>
        </v-col>
      </v-row>

      <!-- Location -->
      <v-select
        v-model="form.region"
        :items="regions"
        item-text="name"
        item-value="id"
        label="Viloyat"
        dense
        outlined
        clearable
        hide-details
        class="mb-3"
      ></v-select>
      <!-- <v-select
        v-model="form.nationality"
        :items="nationalities"
        item-text="name"
        item-value="id"
        label="Millati"
        dense
        outlined
        hide-details
        class="mb-3"
      ></v-select> -->
      <v-select
        v-model="form.marital_status"
        :items="statuses"
        item-text="name"
        item-value="id"
        label="Oilaviy holati"
        dense
        clearable
        outlined
        hide-details
        class="mb-3"
      ></v-select>


      <!-- Age Range slider -->
      <div class="mb-3">
        <div class="d-flex justify-space-between caption">
          <span>Yosh oralig‘i</span>
          <span v-if="form.ageRange">{{ form.ageRange[0] }} - {{ form.ageRange[1] }}</span>
        </div>
        <v-range-slider
          v-model="form.ageRange"
          :min="18"
          :max="70"
          step="1"
          thumb-label
          dense
          color="pink"
        ></v-range-slider>
      </div>

      <!-- Apply Button -->
      <v-btn
        block
        large
        class="white--text rounded-pill mt-4"
        style="background: linear-gradient(90deg, #ff00cc, #3333ff);"
        @click="search"
      >
        Izlash
      </v-btn>
    </v-form>
  </v-card>
</v-bottom-sheet>


  <v-bottom-sheet v-model="candidateDialog" max-width="500px">
    <v-card class="pa-4 rounded-t-xl" style="border-radius: 20px 20px 0 0;">
      <div class="d-flex align-center mb-3">
        <h4
          class="font-weight-bold text-center mb-0"
          :style="{ color: selectedCandidate.gender == 'A' ? '#FF9800' : '#673AB7' }"
        >
          {{ selectedCandidate.gender == 'A' ? 'Kelin' : 'Kuyov' }}
        </h4>

        <v-spacer></v-spacer>

        <!-- Telegram profile button -->
        <v-btn
          v-if="selectedCandidate && selectedCandidate.nickname"
          small
          class="elevated-btn px-3 py-1 white--text"
          style="
            background: linear-gradient(135deg, #0088cc, #34b7f1);
            border-radius: 20px;
            text-transform: none;
          "
          @click="openTelegram(selectedCandidate.nickname)"
        >
          <v-icon left size="18">mdi-airplane</v-icon>
          {{ selectedCandidate.nickname }}
        </v-btn>
      </div>

      <!-- Detallar -->
      <v-row dense class="mb-2">
        <v-col cols="6">
          <strong>Hudud:</strong> {{ selectedCandidate.region?.name }}
        </v-col>
        <v-col cols="6">
          <strong>Yosh:</strong> {{ selectedCandidate.age }}
        </v-col>
        <v-col cols="6">
          <strong>Bo‘yi:</strong> {{ selectedCandidate.height }}
        </v-col>
        <v-col cols="6">
          <strong>Vazn:</strong> {{ selectedCandidate.weight }}
        </v-col>
      </v-row>

      <!-- Chiplar -->
      <div class="d-flex flex-wrap mb-3">
        <v-chip
        v-for="(item, index) in [
          selectedCandidate?.education?.name,
          selectedCandidate?.profession,
          selectedCandidate?.marital_status?.name
        ].filter(Boolean)"
        :key="index"
        small
        color="pink"
        dark
        class="ma-1"
      >
        {{ item }}
      </v-chip>
      </div>

      <v-row>
        <v-col>
          Qo'shimcha: {{ selectedCandidate.about ? selectedCandidate.about.substr(0,300) : "Ma'lumot mavjud emas" }}
        </v-col>
      </v-row>

      <!-- Close button -->
      <v-btn
        block
        large
        class="white--text mt-2"
        style="background: linear-gradient(90deg, #ff4b2b, #ff416c); border-radius: 12px;"
        @click="candidateDialog = false"
      >
        Yopish
      </v-btn>
    </v-card>
  </v-bottom-sheet>

  </v-container>
</template>

<script>
export default {
  name: 'Candidates',
  data() {
    return {
      genders: [
        { id: "E", name: "Kuyov" },
        { id: "A", name: "Kelin" },
      ],
      nationalities: [],
      regions: [],
      educations: [],
      statueses : [],
      form: {
        gender: "",
        region: "",
        nationality: "",
        ageRange: [18, 70],   // slider uchun qulay
      },
      searchDialog: false,
      candidateDialog: false,
      selectedCandidate: {},
      defaultPhoto: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
      candidates: [],
      page: 1,
      perPage: 10,
      hasMore: true,
      fetchingMore: false,
      loading: false,
      snackbar: false,
    }
  },
  methods: {
    openTelegram(nickname) {
      if (!nickname) return;
        const username = nickname.startsWith('@') ? nickname.slice(1) : nickname;
        const url = `https://t.me/${encodeURIComponent(username)}`;

        // Telegram WebApp API orqali ochish (tavsiya etiladi)
        if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.openTelegramLink) {
          window.Telegram.WebApp.openTelegramLink(url); // Mini-app minimizatsiya bo‘ladi
          return;
        }

        // Fallback: agar WebApp API mavjud bo‘lmasa
        // (masalan, dev/prod tashqarisida test qilayotganda)
        try {
          window.location.href = `tg://resolve?domain=${username}`;
          setTimeout(() => { window.location.href = url; }, 800);
        } catch (e) {
          window.location.href = url;
        }
    },
    openCandidate(candidate) {
      this.selectedCandidate = candidate;
      this.candidateDialog = true;
    },
    async getCandidatesPage() {
    if (this.fetchingMore || !this.hasMore) return;

    this.fetchingMore = true;
    try {
      const payload = {
        filter: {
          gender: this.form.gender || null,
          region: this.form.region || null,
          nationality: this.form.nationality || null,
          min_age: Array.isArray(this.form.ageRange) ? this.form.ageRange[0] : null,
          max_age: Array.isArray(this.form.ageRange) ? this.form.ageRange[1] : null,
        },
        page: this.page,
        per_page: this.perPage,
      };

      const res = await axios.post(
        this.$store.state.backend_url + "api/get-candidates-search",
        payload
      );

      // Backend format: { data: [...], has_more: bool, page, per_page }
      const items = Array.isArray(res.data.data) ? res.data.data : [];
      // Dublikatsiyani oldini olish (ixtiyoriy)
      const existing = new Set(this.candidates.map(c => c.id));
      const fresh = items.filter(c => !existing.has(c.id));

      this.candidates = this.candidates.concat(fresh);

      if (typeof res.data.has_more !== 'undefined') {
        this.hasMore = !!res.data.has_more;
      } else {
        this.hasMore = items.length === this.perPage;
      }

      if (this.hasMore) this.page += 1;

    } catch (error) {
      console.error(error);
    } finally {
      this.fetchingMore = false;
    }
    },

    // v-intersect handler
    handleIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.getCandidatesPage();
      }
    },

    // "Izlash" tugmasi bosilganda — yangi filtrlarda qaytadan yuklaymiz
    async search() {
      this.searchDialog = false;
      this.resetAndLoad();
    },
    async getRef() {
      try {
        const res = await axios.get(
          this.$store.state.backend_url + "api/get-profile-datas"
        );
        this.educations = res.data.educations;
        this.nationalities = res.data.nationalities;
        this.regions = res.data.regions;
        this.statuses = res.data.marital_statuses;
      } catch (error) {
        console.error(error);
      }
    },
    resetAndLoad() {
      this.page = 1;
      this.hasMore = true;
      this.candidates = [];
      // this.form = {};
      this.getCandidatesPage();
    },
    resetForm() {
      this.form = {
        gender: "",
        region: "",
        nationality: "",
        ageRange: null,
      };
    },

    // Barchasini ko'rsatish (filtrlarni tozalab, 1-sahifadan yuklash)
    showAll() {
      this.resetForm();
      this.resetAndLoad();  // sizda bor: page=1, candidates=[], hasMore=true va hokazo
    },
    getAlert(){
      alert('test');
    },
  },
  mounted() {
    // this.getCandidates();
    this.resetAndLoad();
    this.getRef();
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 16px;
  transition: 0.3s ease;
}
.v-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.custom-clearable >>> .v-input__icon--clear {
  opacity: 1 !important;
  pointer-events: auto !important;
}

/* Tugma rangini o‘zgartirish */
.custom-clearable >>> .v-input__icon--clear .v-icon {
  color: #9C27B0 !important;
}
.custom-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh !important;
  margin: 0 auto;
}
.custom-dialog >>> .v-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Glassmorphism kartasi */
.glass-card {
  background: rgba(255, 250, 250, 0.702) !important;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border-radius: 20px !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 10px;
  color: #fff;
}

/* Glass button */
.glass-btn {
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  color: rgb(141, 119, 255) !important;
  font-weight: bold;
  transition: 0.3s ease;
}


.candidate-dialog >>> .v-overlay__scrim {
  background: rgba(6, 8, 10, 0.45) !important;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.dialog-close {
  position: absolute;
  right: 10px;
  top: 8px;
  color: rgba(255,255,255,0.8);
}

/* Avatar initials */
.avatar-initials {
  font-weight: 700;
  color: #3b2b1f;
}

/* Text styles */
.name {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}
.meta {
  font-size: 13px;
  color: rgba(255,255,255,0.75);
  display: flex;
  align-items: center;
}
.dot { margin: 0 6px; opacity: 0.6; }

/* Content area scrolling */
.content {
  max-height: 48vh;
  overflow-y: auto;
  padding-right: 6px;
}

/* Small labels and values */
.small-label { color: rgba(255,255,255,0.65); font-size: 12px; }
.value { color: #fff; font-weight: 600; margin-top: 4px; }

/* Skills chips */
.skills .v-chip {
  background: rgba(255,255,255,0.04);
  border-color: rgba(255,255,255,0.08);
  color: #fff;
}

/* About text */
.about { color: rgba(255,255,255,0.9); }

/* Actions */
.action-row { margin-top: 6px; }
.action-left .v-btn,
.action-right .v-btn { color: rgba(255,255,255,0.9); }
.shortlist-btn {
  background: linear-gradient(90deg,#7fb46b,#6fa04e) !important;
  color: white !important;
  box-shadow: 0 6px 14px rgba(79, 125, 63, 0.28);
}

/* Responsive tweaks */
@media (max-width: 600px) {
  .glass-card { border-radius: 12px !important; padding: 12px; }
  .name { font-size: 18px; }
  .avatar-initials { font-size: 16px; }
}
</style>
